import React from "react";
import PropTypes from "prop-types";

function Loader({ className, style, children }) {
  return (
    <div className={`loader ${className}`} style={style}>
      <div className="indicator">
        <div className="logo" />
      </div>
      {children}
    </div>
  );
}

Loader.defaultProps = {
  className: "",
  style: {},
};

Loader.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default Loader;
